import clsx from 'clsx'

const PostsCell =({params})=> {
  const {eventTime, header} = params;
  const title = header || params.title;
  const subtitle = eventTime || params.subtitle;

  return (
    <div className="event_item_info">
      <p className="title date_wrapper">
        {params.subtitle && <span className="type text-lg posts">{subtitle}</span>}
        {params.time && <span className="type text-lg posts">{params.time}</span>}
        {params.type && <span className={clsx("type", params.type)}>{params.type}</span>}
        {title}
      </p>
      <div className="event_detail_block">
        {
          params.artists && <div className="artist">
          <p className="label">アーティスト</p>
            {
              params.artists.map((pa,i)=> <p key={'artist'+i} className="name">{pa.name}</p>)
            }
        </div>
        }

        {
          params.eventTimeDetail && (
            <div className="kanren">
           <p className="label">関連情報</p>
          <p className="name" dangerouslySetInnerHTML={{ __html: params.eventTimeDetail.replace(/,/g, '<br/>')}} />
              {
                params.eventFloor && <p className="name" >{params.eventFloor}</p>
              }
        </div>
          )
        }
      </div>
    </div>
  )
}

export default PostsCell
